import React from 'react'
import HtmlCleanerForm from './HtmlCleanerForm'
import SetTitle from '../../utils/set_title'
import Header from '../../components/Headers/Header'

export default function HtmlCleaner() {
  SetTitle('Html Cleaner')
  const description =
    'Una volta caricati i file html verranno eliminate le prime 10 e ultime 3 righe di ognuno, inoltre tutti i tag h diventeranno h2.'

  return (
    <Header
      iconClass="fa fa-paint-brush"
      title="Html Cleaner"
      docLink="/docs/ranking_tools/html-cleaner/"
      description={description}
    >
      <HtmlCleanerForm />
    </Header>
  )
}